/* Jelly Freakin — theme JS: drawers, AJAX cart, quick-add, variant switching */
(function () {
  'use strict';

  var FMT = (window.themeSettings && window.themeSettings.moneyFormat) || '₹{{ amount }}';

  function formatMoney(cents) {
    var amount = (cents / 100);
    var str = amount.toLocaleString('en-IN', {
      minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return FMT
      .replace(/\{\{\s*amount[^}]*\}\}/, str)
      .replace(/<[^>]+>/g, '');
  }

  /* ---------------- Drawer ---------------- */
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      closeDrawers();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------------- Cart ---------------- */
  function refreshCartDrawer(openAfter) {
    return fetch(window.location.pathname + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections['cart-drawer'];
        if (!html) return;
        var tpl = document.createElement('div');
        tpl.innerHTML = html;
        var fresh = tpl.querySelector('#CartDrawer');
        var current = document.getElementById('CartDrawer');
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.replaceWith(fresh);
          if (wasOpen || openAfter) {
            requestAnimationFrame(function () { openDrawer('CartDrawer'); animateFreeShip(); });
          }
        }
        updateCounts();
        animateFreeShip();
      });
  }

  function updateCounts() {
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (el.textContent !== String(cart.item_count)) {
            el.textContent = cart.item_count;
            el.classList.remove('jiggle');
            void el.offsetWidth;
            el.classList.add('jiggle');
          }
        });
      });
  }

  function animateFreeShip() {
    var fill = document.querySelector('.freeship__fill[data-progress]');
    if (fill) {
      requestAnimationFrame(function () {
        fill.style.width = fill.getAttribute('data-progress') + '%';
      });
    }
  }
  document.addEventListener('DOMContentLoaded', animateFreeShip);

  function cartAdd(variantId, qty) {
    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || window.themeStrings.cartError); });
      return r.json().then(function (data) {
        jfTrack('AddToCart', { content_ids: [String(variantId)], content_type: 'product', currency: 'INR' });
        return data;
      });
    });
  }

  function cartChangeLine(line, qty) {
    return fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(qty) })
    }).then(function (r) { return r.json(); });
  }

  document.addEventListener('click', function (e) {
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      quick.disabled = true;
      quick.classList.add('is-adding');
      cartAdd(quick.getAttribute('data-quick-add'), 1)
        .then(function () { return refreshCartDrawer(true); })
        .catch(function (err) { alert(err.message); })
        .finally(function () { quick.disabled = false; quick.classList.remove('is-adding'); });
      return;
    }

    var qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      e.preventDefault();
      cartChangeLine(qtyBtn.getAttribute('data-line'), qtyBtn.getAttribute('data-qty-change'))
        .then(function () { return refreshCartDrawer(false); });
      return;
    }

    var scrollBtn = e.target.closest('[data-scroll-to]');
    if (scrollBtn) {
      var target = document.querySelector(scrollBtn.getAttribute('data-scroll-to'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  /* ---------------- Product page ---------------- */
  var wrapper = document.querySelector('[data-product-wrapper]');
  if (wrapper) {
    var dataEl = wrapper.querySelector('[data-variants-json]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var form = wrapper.querySelector('[data-product-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    function findVariant(value) {
      return variants.find(function (v) { return v.option === value; });
    }

    function applyVariant(v) {
      if (!v || !idInput) return;
      idInput.value = v.id;

      var img = wrapper.querySelector('[data-main-image]');
      if (img && v.image) { img.src = v.image; img.srcset = ''; }
      if (window.jfHeroSetVideo) window.jfHeroSetVideo(v.video || '', v.video_poster || '');

      wrapper.querySelectorAll('[data-colour-name]').forEach(function (el) { el.textContent = v.option; });

      var price = wrapper.querySelector('[data-price]');
      if (price) price.textContent = formatMoney(v.price);
      var compare = wrapper.querySelector('[data-compare-price]');
      if (compare) {
        if (v.compare_at && v.compare_at > v.price) {
          compare.textContent = formatMoney(v.compare_at);
          compare.hidden = false;
        } else {
          compare.hidden = true;
        }
      }

      var desc = wrapper.querySelector('[data-variant-desc]');
      if (desc && v.desc) desc.innerHTML = v.desc;

      var stock = wrapper.querySelector('[data-stock-badge]');
      if (stock) {
        if (v.show_stock) {
          stock.hidden = false;
          stock.textContent = stock.getAttribute('data-stock-template')
            .replace('[count]', v.qty)
            .replace('[colour]', v.option);
        } else {
          stock.hidden = true;
        }
      }

      var offer = wrapper.querySelector('[data-prepaid-offer]');
      if (offer && offer.getAttribute('data-prepaid-template').indexOf('[save]') !== -1) {
        var opct = Number(offer.getAttribute('data-prepaid-pct')) || 0;
        var osave = Math.round(v.price * opct / 100 / 100) * 100;
        offer.querySelector('[data-prepaid-text]').textContent = offer.getAttribute('data-prepaid-template')
          .replace('[pct]', opct).replace('[save]', formatMoney(osave));
      }

      var atc = wrapper.querySelector('[data-atc]');
      var notifyBtn = wrapper.querySelector('[data-notify-open]');
      if (atc) {
        if (v.available) {
          atc.disabled = false;
          atc.hidden = false;
          atc.textContent = atc.getAttribute('data-atc-template')
            .replace('[colour]', v.option)
            .replace('[price]', formatMoney(v.price));
          if (notifyBtn) notifyBtn.hidden = true;
        } else {
          atc.hidden = true;
          if (notifyBtn) {
            notifyBtn.hidden = false;
            notifyBtn.textContent = notifyBtn.getAttribute('data-notify-template').replace('[colour]', v.option);
          }
        }
      }
      var nd = document.getElementById('NotifyDrawer');
      if (nd) {
        nd.setAttribute('data-notify-variant', v.id);
        nd.setAttribute('data-notify-colour', v.option);
        nd.querySelectorAll('[data-notify-colour-label]').forEach(function (el) { el.textContent = v.option; });
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    wrapper.addEventListener('change', function (e) {
      var input = e.target.closest('.swatch input');
      if (input) applyVariant(findVariant(input.value));
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var atc = wrapper.querySelector('[data-atc]');
        if (atc) { atc.disabled = true; atc.classList.add('is-adding'); }
        cartAdd(idInput.value, 1)
          .then(function () { return refreshCartDrawer(true); })
          .catch(function (err) { alert(err.message); })
          .finally(function () { if (atc) { atc.disabled = false; atc.classList.remove('is-adding'); } });
      });
    }
  }

  /* ---------------- Jelly checkout: details -> OTP -> payment ---------------- */
  function jfTrack(event, params, opts) {
    if (window.fbq) { try { fbq('track', event, params || {}, opts || {}); } catch (e) {} }
  }

  var jc = { root: null, api: '', cart: null, details: null, token: null, config: { prepaid: false, test_mode: false } };
  var JC_KEY = 'jf_checkout_v1';
  function jcSaved() {
    try { return JSON.parse(localStorage.getItem(JC_KEY)) || null; } catch (e) { return null; }
  }
  function jcSave(data) {
    try { localStorage.setItem(JC_KEY, JSON.stringify(data)); } catch (e) {}
  }

  function jcStep(n) {
    jc.root.querySelectorAll('[data-jc-step]').forEach(function (s) {
      s.hidden = s.getAttribute('data-jc-step') !== String(n);
    });
    jc.root.querySelector('.drawer__panel').scrollTop = 0;
  }
  function jcErr(step, msg) {
    var el = jc.root.querySelector('[data-jc-error="' + step + '"]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }
  function jcCartHtml() {
    var html = '';
    jc.cart.items.forEach(function (i) {
      var title = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title : i.product_title;
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/, '_120x$1$2') : '';
      html += '<div class="jc__item">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy" width="44" height="44">' : '') +
        '<span class="jc__item-name">' + title + '<span class="jc__item-qty">×' + i.quantity + '</span></span>' +
        '<span class="jc__item-price">' + formatMoney(i.final_line_price) + '</span></div>';
    });
    html += '<div class="jc__total">Total — ' + formatMoney(jc.cart.total_price) + '</div>';
    return html;
  }

  function jcOpen() {
    jc.root = document.getElementById('JellyCheckout');
    if (!jc.root) return false;
    jc.api = (jc.root.getAttribute('data-api') || '').replace(/\/$/, '');
    if (!jc.api) return false;
    jc.token = null;
    openDrawer('JellyCheckout');
    jcStep(1);
    jcErr(1); jcErr(2); jcErr(3);
    var saved = jcSaved();
    if (saved && saved.details) {
      jc.root.querySelectorAll('[data-jc-step="1"] [data-jc-field]').forEach(function (f) {
        var k = f.getAttribute('data-jc-field');
        if (saved.details[k]) f.value = saved.details[k];
      });
    }
    fetch(window.routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        jc.cart = cart;
        jfTrack('InitiateCheckout', {
          content_ids: cart.items.map(function (i) { return String(i.variant_id); }),
          content_type: 'product',
          num_items: cart.item_count,
          value: cart.total_price / 100,
          currency: 'INR'
        });
      });
    fetch(jc.api + '/api/config')
      .then(function (r) { return r.json(); })
      .then(function (cfg) { jc.config = cfg; })
      .catch(function () {});
    return true;
  }

  // Intercept checkout buttons (cart drawer + cart page)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[action*="/cart"]')) return;
    var hasCheckout = form.querySelector('button[name="checkout"], input[name="checkout"]');
    if (!hasCheckout) return;
    if (!document.getElementById('JellyCheckout')) return; // feature off -> normal Shopify checkout
    e.preventDefault();
    closeDrawers();
    jcOpen();
  }, true);

  function jcReadDetails() {
    var d = {};
    jc.root.querySelectorAll('[data-jc-step="1"] [data-jc-field]').forEach(function (f) {
      d[f.getAttribute('data-jc-field')] = f.value.trim();
    });
    if (!d.name || !d.address1 || !d.city) return { err: 'Fill everything in — the courier needs it all.' };
    if (d.name.length < 3) return { err: 'Your full name, please.' };
    if (!/^\d{10}$/.test(d.phone)) return { err: 'Phone should be 10 digits.' };
    if (d.address1.length < 10 || d.address1.split(/\s+/).length < 2) return { err: 'Full address please — house/flat number, street, locality. Short addresses get lost.' };
    if (d.city.length < 2) return { err: 'City looks too short.' };
    if (!/^\d{6}$/.test(d.pincode)) return { err: 'Pincode should be 6 digits.' };
    return { d: d };
  }

  function jcSendOtp(btn) {
    btn.disabled = true;
    btn.classList.add('is-adding');
    return fetch(jc.api + '/api/otp/send', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: jc.details.phone, details: jc.details, items: jc.cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity }; }) })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-adding'); });
  }

  document.addEventListener('click', function (e) {
    var t;

    if ((t = e.target.closest('[data-jc-details]'))) {
      e.preventDefault();
      var read = jcReadDetails();
      if (read.err) return jcErr(1, read.err);
      jcErr(1);
      jc.details = read.d;
      var saved = jcSaved();
      if (saved && saved.token && saved.phone === jc.details.phone) {
        jc.token = saved.token;
        jcSave({ token: jc.token, phone: jc.details.phone, details: jc.details });
        jcShowPayment();
        return;
      }
      jcSendOtp(t).then(function (res) {
        if (!res.ok) return jcErr(1, res.d.error === 'too_soon' ? 'Hold on 30s, then try again.' : 'Could not send the code. Try again?');
        jc.root.querySelector('[data-jc-phone]').textContent = '+91 ' + jc.details.phone;
        var otpField = jc.root.querySelector('[data-jc-field="otp"]');
        otpField.value = res.d.test_otp || '';
        jcStep(2);
        otpField.focus();
      });
      return;
    }

    if ((t = e.target.closest('[data-jc-resend]'))) {
      e.preventDefault();
      jcSendOtp(t).then(function (res) {
        jcErr(2, res.ok ? '' : (res.d.error === 'too_soon' ? 'Hold on 30s between resends.' : 'Could not resend.'));
        if (res.ok && res.d.test_otp) jc.root.querySelector('[data-jc-field="otp"]').value = res.d.test_otp;
      });
      return;
    }

    if ((t = e.target.closest('[data-jc-back]'))) {
      e.preventDefault();
      jcStep(t.getAttribute('data-jc-back'));
      return;
    }

    if ((t = e.target.closest('[data-jc-verify]'))) {
      e.preventDefault();
      var code = jc.root.querySelector('[data-jc-field="otp"]').value.trim();
      if (!/^\d{6}$/.test(code)) return jcErr(2, 'The code is 6 digits.');
      t.disabled = true;
      t.classList.add('is-adding');
      fetch(jc.api + '/api/otp/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: jc.details.phone, code: code, details: jc.details })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) return jcErr(2, res.d.error === 'expired' ? 'Code expired — resend it.' : 'Wrong code. Look again?');
          jcErr(2);
          jc.token = res.d.token;
          jcSave({ token: jc.token, phone: jc.details.phone, details: jc.details });
          jcShowPayment();
        })
        .finally(function () { t.disabled = false; t.classList.remove('is-adding'); });
      return;
    }

    if ((t = e.target.closest('[data-jc-pay-online]'))) {
      e.preventDefault();
      if (jc.config.provider === 'cashfree') jcCashfree(t);
      else jcRazorpay(t);
      return;
    }

    if ((t = e.target.closest('[data-jc-cod]'))) {
      e.preventDefault();
      if (jc.config.partial_cod > 0 && jc.config.prepaid) {
        if (jc.config.provider === 'cashfree') jcCashfree(t, 'partial');
        else jcRazorpay(t, 'partial');
      } else {
        jcPlace(t, 'cod');
      }
      return;
    }
  });

  function jcShowPayment() {
    jc.root.querySelector('[data-jc-summary]').innerHTML = jcCartHtml() +
      '<div class="jc__colour-line" style="margin-top: 8px;">' + jc.details.name + ' · +91 ' + jc.details.phone + '<br>' +
      jc.details.address1 + ', ' + jc.details.city + ' ' + jc.details.pincode + '</div>';
    var full = jc.cart.total_price;
    var pct = jc.config.prepaid_discount || 0;
    var online = Math.round(full * (100 - pct) / 100 / 100) * 100;
    var payBtn = jc.root.querySelector('[data-jc-pay-online]');
    var codBtn = jc.root.querySelector('[data-jc-cod]');
    var saveLine = jc.root.querySelector('[data-jc-save]');
    payBtn.hidden = !jc.config.prepaid;
    var advance = (jc.config.partial_cod > 0 && jc.config.prepaid) ? Math.min(jc.config.partial_cod * 100, full) : 0;
    if (codBtn) {
      codBtn.textContent = advance
        ? 'Cash on delivery — pay ' + formatMoney(advance) + ' now, ' + formatMoney(full - advance) + ' at your door'
        : 'Cash on delivery — ' + formatMoney(full);
    }
    if (jc.config.prepaid && pct > 0) {
      payBtn.innerHTML = 'Pay online — ' + formatMoney(online) + ' <s class="jc__was">' + formatMoney(full) + '</s>';
      saveLine.textContent = 'Pay online and save ' + formatMoney(full - online) + '. ' + (advance ? 'COD needs a small ' + formatMoney(advance) + ' advance to confirm.' : 'COD pays full price.');
      saveLine.hidden = false;
    } else if (jc.config.prepaid) {
      payBtn.textContent = 'Pay online — ' + formatMoney(online);
      saveLine.hidden = true;
    } else {
      saveLine.hidden = true;
    }
    fetch(jc.api + '/api/checkout/started', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jcOrderBody())
    }).catch(function () {});
    jfTrack('AddPaymentInfo', {
      content_ids: jc.cart.items.map(function (i) { return String(i.variant_id); }),
      value: jc.cart.total_price / 100,
      currency: 'INR'
    });
    jcStep(3);
  }

  function jcExpiredToOtp(btn) {
    // stored token no longer valid -> clear it and run the OTP step
    jcSave({ details: jc.details });
    jc.token = null;
    jcSendOtp(btn).then(function (res) {
      if (res.ok) {
        jc.root.querySelector('[data-jc-phone]').textContent = '+91 ' + jc.details.phone;
        var otpField = jc.root.querySelector('[data-jc-field="otp"]');
        otpField.value = res.d.test_otp || '';
        jcStep(2);
        otpField.focus();
      } else {
        jcErr(3, 'Verification expired — go back and try again.');
      }
    });
  }

  function jcOrderBody() {
    return {
      token: jc.token,
      items: jc.cart.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, image: i.image || null }; }),
      total: jc.cart.total_price / 100,
      name: jc.details.name, phone: jc.details.phone,
      address1: jc.details.address1, city: jc.details.city, pincode: jc.details.pincode
    };
  }

  function jcSuccess(orderName, paidValue, dueRupees) {
    jfTrack('Purchase', {
      content_ids: jc.cart.items.map(function (i) { return String(i.variant_id); }),
      content_type: 'product',
      num_items: jc.cart.item_count,
      value: (typeof paidValue === 'number' ? paidValue : jc.cart.total_price) / 100,
      currency: 'INR'
    }, { eventID: 'jf-' + orderName });
    var head = jc.root.querySelector('[data-jc-step="4"] .drawer__title');
    var isPre = jc.config.preorder || jc.root.getAttribute('data-preorder') === 'true';
    if (isPre && head) head.textContent = 'Preorder placed.';
    jc.root.querySelector('[data-jc-ordername]').textContent = (isPre ? 'Preorder ' : 'Order ') + orderName + ' — we\'ll WhatsApp you when it ships.' + (dueRupees ? ' Keep ' + formatMoney(dueRupees * 100) + ' ready for the courier.' : '');
    jcStep(4);
    fetch(window.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: 1, quantity: 0 }) }).catch(function () {});
    var clearNext = function () {
      fetch(window.routes.cart_url + '.js').then(function (r) { return r.json(); }).then(function (c) {
        if (c.item_count > 0) {
          fetch(window.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: 1, quantity: 0 }) }).then(clearNext);
        } else {
          updateCounts();
          refreshCartDrawer(false);
        }
      });
    };
    clearNext();
  }

  function jcPlace(btn, kind) {
    btn.disabled = true;
    btn.classList.add('is-adding');
    fetch(jc.api + '/api/checkout/' + kind, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(jcOrderBody())
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (res.d && res.d.error === 'not_verified') { jcExpiredToOtp(btn); return; }
        if (!res.ok || !res.d.ok) throw new Error(res.d.error || 'failed');
        jcSuccess(res.d.order_name, jc.cart.total_price);
      })
      .catch(function () { jcErr(3, 'Something slipped. Try again?'); })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-adding'); });
  }

  function jcRazorpay(btn, mode) {
    btn.disabled = true;
    btn.classList.add('is-adding');
    var ensureScript = window.Razorpay
      ? Promise.resolve()
      : new Promise(function (resolve, reject) {
          var s = document.createElement('script');
          s.src = 'https://checkout.razorpay.com/v1/checkout.js';
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
    ensureScript
      .then(function () {
        var createBody = jcOrderBody();
        if (mode === 'partial') createBody.mode = 'partial';
        return fetch(jc.api + '/api/checkout/razorpay/create', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(createBody)
        }).then(function (r) { return r.json(); });
      })
      .then(function (d) {
        if (d.error === 'not_verified') { jcExpiredToOtp(btn); return; }
        if (!d.ok) throw new Error(d.error || 'failed');
        var rzp = new window.Razorpay({
          key: d.key_id,
          order_id: d.rp_order_id,
          amount: d.amount,
          currency: 'INR',
          name: 'Jellypop',
          prefill: { contact: '91' + jc.details.phone, name: jc.details.name },
          theme: { color: '#D6538F' },
          handler: function (resp) {
            var body = jcOrderBody();
            body.rp_order_id = resp.razorpay_order_id;
            body.rp_payment_id = resp.razorpay_payment_id;
            body.rp_signature = resp.razorpay_signature;
            fetch(jc.api + '/api/checkout/razorpay/confirm', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body)
            })
              .then(function (r) { return r.json(); })
              .then(function (out) {
                if (!out.ok) throw new Error(out.error || 'failed');
                var discounted = out.partial ? jc.cart.total_price : Math.round(jc.cart.total_price * (100 - (jc.config.prepaid_discount || 0)) / 100 / 100) * 100;
                jcSuccess(out.order_name, discounted, out.partial ? out.due : 0);
              })
              .catch(function () { jcErr(3, 'Payment went through but the order call slipped — message us with your payment ID, we see it on our side too.'); });
          }
        });
        rzp.open();
      })
      .catch(function () { jcErr(3, 'Could not start the payment. Try again?'); })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-adding'); });
  }

  function jcCashfree(btn, mode) {
    btn.disabled = true;
    btn.classList.add('is-adding');
    var ensure = window.Cashfree
      ? Promise.resolve()
      : new Promise(function (resolve, reject) {
          var s = document.createElement('script');
          s.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
          s.onload = resolve;
          s.onerror = reject;
          document.head.appendChild(s);
        });
    ensure
      .then(function () {
        var createBody = jcOrderBody();
        if (mode === 'partial') createBody.mode = 'partial';
        return fetch(jc.api + '/api/checkout/cashfree/create', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(createBody)
        }).then(function (r) { return r.json(); });
      })
      .then(function (d) {
        if (d.error === 'not_verified') { jcExpiredToOtp(btn); return; }
        if (!d.ok) throw new Error(d.error || 'failed');
        var cashfree = window.Cashfree({ mode: d.mode === 'sandbox' ? 'sandbox' : 'production' });
        return cashfree
          .checkout({ paymentSessionId: d.payment_session_id, redirectTarget: '_modal' })
          .then(function () {
            var body = jcOrderBody();
            body.cf_order_id = d.cf_order_id;
            return fetch(jc.api + '/api/checkout/cashfree/confirm', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(body)
            }).then(function (r) { return r.json(); });
          });
      })
      .then(function (out) {
        if (!out.ok) {
          jcErr(3, out.error === 'not_paid' ? 'Payment not completed — nothing charged, try again.' : 'Something slipped. Try again?');
          return;
        }
        var discounted2 = out.partial ? jc.cart.total_price : Math.round(jc.cart.total_price * (100 - (jc.config.prepaid_discount || 0)) / 100 / 100) * 100;
        jcSuccess(out.order_name, discounted2, out.partial ? out.due : 0);
      })
      .catch(function () { jcErr(3, 'Could not start the payment. Try again?'); })
      .finally(function () { btn.disabled = false; btn.classList.remove('is-adding'); });
  }

  /* ---------------- Load more (aux collection grid) ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-load-more]');
    if (!btn) return;
    e.preventDefault();
    fetch(btn.href)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.querySelector('[data-collection-grid]');
        var newGrid = doc.querySelector('[data-collection-grid]');
        if (grid && newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (child) { grid.appendChild(child.cloneNode(true)); });
        }
        var newBtn = doc.querySelector('[data-load-more]');
        if (newBtn) { btn.href = newBtn.href; } else { btn.closest('.load-more-wrap').remove(); }
        observeFadeUps();
      });
  });

  /* ---------------- UGC videos: play in view ---------------- */
  function pauseOtherUgc(current) {
    document.querySelectorAll('.ugc__card video').forEach(function (o) {
      if (o !== current) o.pause();
    });
  }

  function setupUgcVideos() {
    var vids = document.querySelectorAll('.ugc__card video');
    if (!vids.length) return;
    vids.forEach(function (v) {
      var card = v.closest('.ugc__card');
      if (!card) return;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
      v.addEventListener('play', function () {
        card.classList.add('is-playing');
        pauseOtherUgc(v);
      });
      v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    });
    if (!('IntersectionObserver' in window)) return;
    var vo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.dataset.userPlayed) {
            v.play().catch(function () {});
          } else {
            v.muted = true;
            v.play().catch(function () {});
          }
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { vo.observe(v); });
  }
  document.addEventListener('DOMContentLoaded', setupUgcVideos);

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-ugc-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var video = toggle.closest('.ugc__card').querySelector('video');
    if (!video) return;
    if (video.paused) {
      video.muted = false;
      video.dataset.userPlayed = '1';
      video.play().catch(function () {});
    } else {
      video.pause();
    }
  });

  /* ---------------- Fade-ups ---------------- */
  var observer;
  function observeFadeUps() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.fade-up').forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    observer = observer || new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.fade-up:not(.is-visible)').forEach(function (el) { observer.observe(el); });
  }
  document.addEventListener('DOMContentLoaded', observeFadeUps);

  /* ---------------- Back-in-stock waitlist (sold-out PDP) ---------------- */
  (function () {
    var nd = document.getElementById('NotifyDrawer');
    if (!nd) return;
    document.body.appendChild(nd); // escape any transformed ancestor so it layers above everything
    var form = nd.querySelector('[data-notify-form]');
    var done = nd.querySelector('.notify__done');
    var err = form.querySelector('.waitlist__error');
    var btn = form.querySelector('.waitlist__submit');
    var api = ((window.themeSettings && window.themeSettings.checkoutApi) || '').replace(/\/$/, '');
    function key() { return 'jf_notify_' + nd.getAttribute('data-notify-variant'); }
    function prefill() {
      try {
        var saved = JSON.parse(localStorage.getItem('jf_checkout_v1') || 'null');
        if (saved && saved.details) {
          if (!form.name.value) form.name.value = saved.details.name || '';
          if (!form.phone.value) form.phone.value = saved.details.phone || '';
        }
      } catch (e) {}
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-notify-open]');
      if (!t) return;
      e.preventDefault();
      var already = false;
      try { already = !!localStorage.getItem(key()); } catch (e2) {}
      form.hidden = already; done.hidden = !already;
      if (!already) prefill();
      nd.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (!already) setTimeout(function () { (form.name.value ? form.phone : form.name).focus(); }, 350);
    });
    function fail(msg) { err.textContent = msg; err.hidden = false; btn.classList.remove('is-busy'); btn.disabled = false; }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.hidden = true;
      var name = form.name.value.trim();
      var phone = form.phone.value.replace(/\D/g, '');
      if (phone.length === 12 && phone.indexOf('91') === 0) phone = phone.slice(2);
      if (!name) return fail('Tell us your name.');
      if (!/^[6-9]\d{9}$/.test(phone)) return fail('Enter a 10-digit WhatsApp number.');
      if (!api) return fail('Waitlist is not connected yet.');
      btn.classList.add('is-busy'); btn.disabled = true;
      fetch(api + '/api/waitlist', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: name, phone: phone, source: 'back-in-stock',
          variant_id: nd.getAttribute('data-notify-variant'),
          product: nd.getAttribute('data-notify-product'),
          colour: nd.getAttribute('data-notify-colour')
        })
      }).then(function (r) { return r.text().then(function (t) { var j = null; try { j = JSON.parse(t); } catch (e3) {} return { ok: r.ok, status: r.status, j: j }; }); })
        .then(function (res) {
          if (!res.ok || !res.j) {
            var code = res.j && res.j.error;
            return fail(code === 'too_many' ? 'Too many tries — give it a minute.' : code === 'invalid_phone' ? 'That number doesn\'t look right.' : 'Could not save just now (' + res.status + '). Try again in a minute.');
          }
          try { localStorage.setItem(key(), '1'); } catch (e2) {}
          if (window.fbq) fbq('track', 'Lead', { content_name: nd.getAttribute('data-notify-colour') });
          btn.classList.remove('is-busy'); btn.disabled = false;
          form.hidden = true; done.hidden = false;
        })
        .catch(function () { fail('Could not reach the server. Check your connection and try again.'); });
    });
  })();

  /* ---------------- PDP hero gallery: per-colour video + still ---------------- */
  (function () {
    var g = document.querySelector('[data-hero-gallery]');
    if (!g) return;
    var track = g.querySelector('[data-hero-track]');
    var vslide = g.querySelector('[data-hero-video-slide]');
    var dots = g.querySelector('[data-hero-dots]');
    var muteBtn = g.querySelector('[data-hero-mute]');
    function video() { return vslide.querySelector('video'); }
    function setDot() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      dots.querySelectorAll('i').forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      var v = video();
      if (v) { if (i === 0) v.play().catch(function () {}); else v.pause(); }
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(setDot); }, { passive: true });
    if (muteBtn) muteBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var v = video(); if (!v) return;
      v.muted = !v.muted;
      muteBtn.textContent = v.muted ? '\uD83D\uDD07' : '\uD83D\uDD0A';
      if (v.paused) v.play().catch(function () {});
    });
    window.jfHeroSetVideo = function (src, poster) {
      var v = video();
      if (!src) {
        if (v) { v.pause(); v.removeAttribute('src'); v.load(); }
        vslide.hidden = true; dots.hidden = true; g.classList.remove('has-video');
        track.scrollTo({ left: 0 });
        return;
      }
      if (!v) {
        v = document.createElement('video');
        v.className = 'hero-gallery__video';
        v.loop = true; v.muted = true; v.playsInline = true; v.autoplay = true; v.preload = 'metadata';
        v.setAttribute('playsinline', ''); v.setAttribute('muted', '');
        vslide.insertBefore(v, vslide.firstChild);
      }
      if (v.getAttribute('data-src') !== src) {
        v.pause();
        if (poster) v.poster = poster;
        v.src = src; v.setAttribute('data-src', src); v.load();
      }
      vslide.hidden = false; dots.hidden = false; g.classList.add('has-video');
      if (muteBtn) muteBtn.textContent = '\uD83D\uDD07';
      v.muted = true;
      track.scrollTo({ left: 0, behavior: 'smooth' });
      v.play().catch(function () {});
    };
    var v0 = video();
    if (v0) { v0.setAttribute('data-src', v0.currentSrc || (v0.querySelector('source') || {}).src || ''); v0.play().catch(function () {}); }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var v = video(); if (!v || vslide.hidden) return;
        if (en[0].isIntersecting && Math.round(track.scrollLeft / track.clientWidth) === 0) v.play().catch(function () {}); else v.pause();
      }, { threshold: .3 }).observe(g);
    }
  })();
})();
